import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchEmployeesApi } from "./employeesApi";

export const fetchEmployees = createAsyncThunk(
  "employees/fetchEmployees",
  async ({ branchId, year, month }, { rejectWithValue }) => {
    try {
      const data = await fetchEmployeesApi(branchId, year, month);
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.ExceptionMessage || error.response.data.message || "Personel listesi alınamadı.");
      }
      return rejectWithValue("Personel listesi alınırken bağlantı hatası oluştu.");
    }
  }
);
